import React from 'react';
import { Button, ButtonTemplateProps, ButtonVariant } from '..';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';

interface NextButtonProps extends ButtonTemplateProps {}

export default function NextButton(props: NextButtonProps) {
  return <Button text={t(TranslationKey.next).singular.upper} variant={ButtonVariant.primary} {...props} />;
}
